var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Surname","loading":_vm.loading,"color":_vm.themes.candidate.light.input},on:{"blur":_vm.submit,"input":_vm.fixCase},model:{value:(_vm.profile.lastName),callback:function ($$v) {_vm.$set(_vm.profile, "lastName", $$v)},expression:"profile.lastName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }